import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { Grid, Shelf, useResponsiveDisplayMode } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import { useHasMedicarePlans } from "@/premium/hooks/useHasMedicarePlans";
import { EnrollmentContext } from "@/state";

import "./Footer.scss";

export const Footer: FC = () => {
  const [state, _] = useContext(EnrollmentContext);
  const hasMedicarePlans = useHasMedicarePlans();
  const medicareMaterialId = state.experienceData.theme.medicare_material_id;

  const displayMode = useResponsiveDisplayMode();
  const containerClassName = displayMode === "desktop" ? "page-layout-grid" : "page-layout-grid page-layout-grid-mobile";

  const { t: translate } = useTranslation();
  return (
    <Grid className={containerClassName}>
      {displayMode === "desktop" && <Grid.Span columns={1} />}
      <Grid.Span columns={displayMode === "desktop" ? 10 : 12}>
        <div className="enrollment-footer-container">
          <Shelf>
            <Shelf>
              {hasMedicarePlans && medicareMaterialId && (
                <Body>
                  <Semibold>{medicareMaterialId} </Semibold>
                </Body>
              )}
              <div>© {new Date().getFullYear()} Capital Rx</div>
              <a href="https://www.cap-rx.com/legal#legal-notice-privacy-policy">{translate("FOOTER.legalNotices")}</a>
            </Shelf>
            <Shelf.Spacer />
          </Shelf>
        </div>
      </Grid.Span>
      {displayMode === "desktop" && <Grid.Span columns={1} />}
    </Grid>
  );
};
